<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import DataUtil from '@/views/mis/util/data'
    
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "view"){
                    this.$router.push({path:"/mis/emailSend/edit",query:{id:row.id,view:1,label:"MIS"}});
                } else if (clickName == "delete"){
                    this.dataChanage(URL.email.deleteLogId,{id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.query') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t('mis.emailSend.sendEmail') == clickName){
                    this.$router.push({path:"/mis/emailSend/edit",query:{label:"MIS"}});
                }
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t('mis.emailSend.title'), field: 'title'},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.emailSend.sendEmail')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.email.logQuery, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.emailSend.title'), field: 'title'},
                        { title: window.$t('mis.emailSend.sendCount'), field: 'sendCount'},
                        { title: window.$t('mis.emailSend.sucCount'), field: 'sucCount'},
                        { title: window.$t('mis.emailSend.failCount'), field: 'failCount'},
                        { title: window.$t('mis.emailSend.updateDate'), field: 'updateDate'},
                        {title:window.$t('mis.bt.operation'),btnClick:[{name:window.$t('mis.bt.view'),click:"view",type:"primary",icon:"el-icon-view"},{name:window.$t('mis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"},
                                    ]},
                    ]
                }
            }
        }
    }
</script>
